import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_regular_weekly_hours_worked_at_the_fac'

export const dataPointDefinition = {
  retracedId: 'num_of_regular_weekly_hours_worked_at_the_fac',
  name: 'Number of regular weekly hours worked at the facility:',
  description:
    '"Regular hours" refers to those hours worked at regular pay (pre-overtime hours). It is number of hours workers are expected to work as governed by facility\'s schedule.\r\r\n\r\r\nRegular hours are also referred to as "standard working hours" or "normal working hours" or "base hours."',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-5',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6580,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
